// Source: https://www.30secondsofcode.org/js/s/equals

// rome-ignore lint/suspicious/noExplicitAny: <explanation>
export const arrayDeepEqual = (a: Array<any>, b: Array<any>): boolean => {
  if (a === b) {
    return true;
  }

  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  if (!a || !b || (typeof a !== "object" && typeof b !== "object")) {
    return a === b;
  }

  // @ts-expect-error
  if (a.prototype !== b.prototype) return false;

  const keys = Object.keys(a);
  if (keys.length !== Object.keys(b).length) return false;

  // @ts-expect-error
  return keys.every((k) => arrayDeepEqual(a[k], b[k]));
};
